
import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'

const reducers = {}
const initialState = {
    reportPageList:'',
    handelShowUpload:false,//控制是否开启图片上传
    uploadImgArr:[] ,//图片上传暂存容器,
    selectAllCarPics: false, //图片上传默认非全选
}

reducers[types.SEARCH_REPORT_FINISH]={
    next(state, action) {
        return Object.assign({}, state, {
            reportPageList: action.payload.data.result,
            handelShowUpload:false,
            uploadImgArr:[]
        })
    },
    throw(state,action){
        return Object.assign({}, state, {loadError: true})
    }
}


reducers[types.SELECTED_REPORT] = (state, action) => {
    return Object.assign({}, state, {
        handelShowUpload:false,
        uploadImgArr:[]
    })
}

reducers[types.UPLOAD_IMG_START_FINISH] = (state,action)=>{
    if(!action.payload){
        return Object.assign({}, state, {
            handelShowUpload:action.payload,
            uploadImgArr:[],
            selectAllCarPics: false
        })
    }else {
        return Object.assign({}, state, {
            handelShowUpload:action.payload,
        })
    }

}



export default handleActions(reducers, initialState)